import { apiRequest, buildQuery } from './client';

const toContact = (contact) => ({
  ...contact,
  img: contact.sensitiveAvatar
    ? '/assets/images/global/user_sensitive_img_v2.jpg'
    : contact.avatarUrl || '/assets/images/global/user.jpg',
});

const toRequest = (request) => ({
  ...request,
  senderName: request.senderName || request.senderLabel || request.senderHandle || 'Unknown',
  img: request.senderSensitiveAvatar
    ? '/assets/images/global/user_sensitive_img_v2.jpg'
    : request.senderAvatarUrl || '/assets/images/global/user.jpg',
});

export const contactsApi = {
  list: async (options) => {
    const page = await apiRequest(`/api/v1/me/contacts${buildQuery(options)}`);
    return { ...page, items: page.items.map(toContact) };
  },
  update: async (userId, changes) => toContact(await apiRequest(`/api/v1/me/contacts/${userId}`, { method: 'PATCH', body: changes })),
  remove: (userId) => apiRequest(`/api/v1/me/contacts/${userId}`, { method: 'DELETE' }),
  requests: async (options) => {
    const page = await apiRequest(`/api/v1/me/contact-requests${buildQuery(options)}`);
    return { ...page, items: page.items.map(toRequest) };
  },
  sendRequest: (recipientId) => apiRequest('/api/v1/me/contact-requests', { method: 'POST', body: { recipientId } }),
  acceptRequest: async (requestId) => toContact(await apiRequest(`/api/v1/me/contact-requests/${requestId}/accept`, { method: 'POST' })),
  dismissRequest: (requestId) => apiRequest(`/api/v1/me/contact-requests/${requestId}`, { method: 'DELETE' }),
};
